<!-- //
ftp列表管理
@auth xuyd
@date 2025-07-20
//-->
<template>
  <page-layout layout="C">
    <!-- 检索区域 -->
    <div class="layout-search flex-row flex-halign-between">
      <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
               label-width="100px">
        <el-form-item prop="search">
          <el-input
              v-model="queryParams.search"
              placeholder="请输入内容检索"
              style="width: 320px;text-align: right;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="layout-result" style="height: calc(100% - 63px);">
<!--      <vxe-toolbar :buttons="toolbarButtons" @button-click="buttonClickEvent"></vxe-toolbar>-->
      <vxe-toolbar>
        <template #buttons>
          <vxe-button status="primary" @click="handleOpenDialog" :disabled="selectedList.length <= 0">每日计提赎回</vxe-button>
        </template>
      </vxe-toolbar>
      <!-- 子table单选 -->
      <div style="height: calc(100% - 50px);">
        <vxe-table ref="refMainTable"
                   border
                   height="100%"
                   :data="tableData.records"
                   :loading="tableData.tableLoading"
                   :virtual-y-config="{enabled: true, gt:10}"
                   :expand-config="{expandAll: true}"
                   :reserve="true"
                   :row-config="{isHover: true, keyField: 'id'}"
                   :cell-config="{height: 40}"
                   :checkbox-config="checkboxConfig"
                   @scroll="handleScroll"
                   @checkbox-all="handleMainSelectAll"
                   @checkbox-change="handleMainSelect">
          <vxe-column type="checkbox" width="60" align="center"></vxe-column>
          <vxe-column type="expand" width="60" align="center" title="展开">
            <template #content="{ row }">
              <div class="expand-sub-wrapper">
                <SimpleTable :ref="'refSingleSubTable' + row.id"
                             :meta-data="subTableMetaData"
                             :data="row.investCodeAndNameS"
                             :table-id="row.id"
                             rowKey="id"
                             :enable-status="row.checkStatus"
                             v-model="row.selectSubRowId"
                             :style="{width: getInnerTableWidth(), 'background-color': '#f6f5f8'}"
                             @change="(val) => handleSubSingleSelect(val, row)">
                </SimpleTable>
              </div>
            </template>
          </vxe-column>
          <vxe-column title="ID" field="id" width="80"></vxe-column>
          <vxe-column title="通道" field="channelCode" width="100"></vxe-column>
          <vxe-column title="赎回状态" field="status" width="100"></vxe-column>
          <vxe-column title="商品名称" field="projectCode" width="200"></vxe-column>
          <vxe-column title="余额" field="balance" minWidth="200" :formatter="moneyFormatter"></vxe-column>
          <vxe-column title="描述" field="projectName" minWidth="200"></vxe-column>
          <vxe-column title="描述" field="projectName" minWidth="200"></vxe-column>
          <vxe-column title="描述" field="projectName" minWidth="200"></vxe-column>
          <vxe-column title="描述" field="projectName" minWidth="200"></vxe-column>
        </vxe-table>
      </div>
      <!--分页组件-->
      <pagination v-if="!tableData.hidePagination" :total="tableData.total"
                  :pageNum.sync="queryParams.pageNum" :pageSize.sync="queryParams.pageSize"
                  @pagination="getList"/>
    </div>
  </page-layout>
</template>

<script>
import SimpleTable from '@/components/Table/SimpleTable';
import {debounce} from 'xe-utils'

const templateMainData = {
  "id": 1983,
  "channelCode": "nyt11983",
  "selectSubRowId": null,
  "projectCode": "WT2X",
  "status": "0",
  "projectName": "上信睿赢-兴证心选【1983】号家庭服务信托",
  "investCodeAndNameS": []
};
const templateSubData = {
  "id": "1983-1",
  "investCode": "MM4500",
  "investName": "睿赢智管家产品",
  "projectCode": "WT2X",
  "subProjectCode": "WT2X1983",
  "sumConfirmShares": 10000.575
}
export default {
  name: 'ViewTableList',
  components: {SimpleTable},
  dictTypes: [],
  data() {
    return {
      checkboxConfig: {
        labelField: 'name', checkMethod: ({row}) => {
          return row.checkStatus
        }
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: null,
        isAsc: null,
        search: null,
      },
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
      subTableMetaData: [
        {prop: 'checked', label: "单选", type: "radio", width: 60},
        {prop: 'id', label: "ID", width: 80, sortable: true},
        {prop: 'investCode', label: "投资品Code", width: 100},
        {prop: 'investCode', label: "投资品名称", width: 120},
        {prop: 'projectCode', label: "项目Code", width: 100},
        {prop: 'subProjectCode', label: "子项目Code", width: 120},
        {
          prop: 'sumConfirmShares',
          label: "合计确认份额",
          width: 120,
          format: (row) => this.$util.currencyFormat(row.sumConfirmShares, 2)
        },
      ],
      toolbarButtons: [
        {name: '每日计提赎回', code: 'openModal', status: 'primary'},
      ],
      scrollLeft: 0,
      scrollToFunc: debounce((scrollLeft, scrollTop) => {
        // console.log("-----scrollLeft", scrollLeft)
        if (this.scrollLeft === scrollLeft) {
          return;
        }
        const refMainTable = this.$refs['refMainTable'];
        this.$nextTick(() => {
          let expandSubWrappers = refMainTable.$el.querySelectorAll('.expand-sub-wrapper');
          if (expandSubWrappers && expandSubWrappers.length && expandSubWrappers.length > 0) {
            expandSubWrappers.forEach(item => {
              item.scrollLeft = scrollLeft;
              this.scrollLeft = scrollLeft;
            });
          } else {
            expandSubWrappers.scrollLeft = scrollLeft;
            this.scrollLeft = scrollLeft;
          }
        });
      }, 10),
      // 列表选择的数据记录
      selectedList:[]
    };
  },
  created() {
    this.getList();
  },
  methods: {

    /**
     * 主表的width
     */
    getInnerTableWidth() {
      const refMainTable = this.$refs['refMainTable'];
      if (refMainTable) {
        // 获取主表的table的宽度
        let $mainTableHeader = refMainTable.$el.querySelector('.vxe-table--header');
        if ($mainTableHeader) {
          let clientWidth = $mainTableHeader.clientWidth - 59; // padding-left
          // console.log("--------clientWidth", clientWidth);
          return `${clientWidth}px`;
        }
      }
      return `100%`;
    },

    /**
     * 主表的all checkbox的选择事件
     * @param checked
     * @param $event
     * @param records
     */
    handleScroll({scrollLeft, scrollTop}) {
      this.scrollToFunc(scrollLeft, scrollTop);
    },

    /**
     * 主表的all checkbox的选择事件
     * @param checked
     * @param $event
     * @param records
     */
    handleMainSelectAll({checked, $event, records}) {
      // console.log("---handleParentSelectAll-----", checked, $event)
      // 全量勾选时候
      if (checked) {//设置所有子table选择
        this.$nextTick(() => {
          records.forEach(row => {
            row.selectSubRowId = row.investCodeAndNameS[0].id;
          })
          this.putSelectedList();
        });
      } else {// 清除所有子table选择
        this.$nextTick(() => {
          this.tableData.records.forEach(row => {
            row.selectSubRowId = null;
          })
          this.putSelectedList();
        })
      }
    },
    /**
     * 主表的checkbox的选择事件
     * @param checked
     * @param row
     */
    handleMainSelect({checked, row}) {
      // console.log("---handleParentSelect-----", checked, row)
      // 当前行事件，如果当前行在list中，则是选择，否则未选择
      if (checked) {// 选择
        this.$nextTick(() => {
          row.selectSubRowId = row.investCodeAndNameS[0].id;
          this.putSelectedList();
        })
      } else {// 未选中
        this.$nextTick(() => {
          row.selectSubRowId = null;
          this.putSelectedList();
        })
      }
    },
    /**
     * 子表的radio的选择事件
     * @param opts
     * @param parentRow
     */
    handleSubSingleSelect(opts, parentRow) {
      // console.log("---handleSubSingleSelect-----", opts, parentRow)
      this.$nextTick(() => {
        const refMainTable = this.$refs['refMainTable'];
        if (refMainTable) {
          refMainTable.setCheckboxRow([parentRow], true);
          this.putSelectedList();
        }
      });
    },

    /**
     * 列表数据查询
     */
    getList() {
      let records = [];
      let limit = 10000;
      let subLimit = 5;
      for (let i = 0; i < limit; i++) {
        let data = JSON.parse(JSON.stringify(templateMainData));
        data.id = i;
        let max = Number.parseInt(Math.random() * subLimit);
        for (let j = 0; j < max; j++) {
          let subData = JSON.parse(JSON.stringify(templateSubData));
          subData.id = i + "-" + j;
          data.investCodeAndNameS = data.investCodeAndNameS || [];
          data.investCodeAndNameS.push(subData);
        }
        data.status = data.investCodeAndNameS.length % 2;// 随机生成状态
        data.checkStatus = (data.investCodeAndNameS && data.investCodeAndNameS.length > 0 && data.status == '1');
        records.push(data);
      }
      // records = investData;
      setTimeout(() => {
        // 初始化展示控制的字段数据
        this.tableData.records = records.map(item => {
              item.selectSubRowId = "";
              item.investCodeAndNameS.forEach(subItem => subItem.checked = '');
              return item;
            }
        );
        this.tableData.total = records.length * 2;// 模拟分页

        this.$nextTick(() => {
          const refMainTable = this.$refs['refMainTable'];
          if (refMainTable) {
            refMainTable.setAllRowExpand(true);
            refMainTable.clearCheckboxRow();// TODO 如果选择内部单选，再次查询，没有消失
          }
        });
      }, 2000);
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm("refQueryForm");
      this.$refs.refQueryForm.resetFields();
      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;
      // =========重置(S)========
      this.queryParams.monitorStatus = [];
      // =========重置(E)========
      this.handleQuery();
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      // console.log("----handleSortChange---->", JSON.stringify(column));
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.getList();
    },
    /** 金额格式化 **/
    moneyFormatter({cellValue, row}) {
      let val = cellValue;
      console.log(val)
      val = "57689802.33";
      return this.$util.currencyFormat(val);
    },

    /** 获取选中 **/
    putSelectedList() {
      const refMainTable = this.$refs.refMainTable;
      if (refMainTable) {
        let list = [];
        const selectRecords = refMainTable.getCheckboxRecords();
        selectRecords.forEach(record => {
          if(record.investCodeAndNameS) {
            // 这里用==判断，id可能被转成字符串
            list.push(record.investCodeAndNameS.find(item => item.id == record.selectSubRowId));
          }
        });
        this.selectedList = list;
      }
    },

    // 打开对话框
    handleOpenDialog() {
      this.$modal.alert(`${this.selectedList.length}条数据：${JSON.stringify(this.selectedList)}`);
      console.log("--->", this.selectedList)
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.vxe-checkbox--label) {
  display: none;
}

.expand-sub-wrapper {
  padding-left: 59px;
  width: 100%;
  overflow-x: hidden;
}
</style>
